<template>
  <div id="app">
    <b-container>
    
    <RettungEintragen/>
  
  </b-container>
  </div>
</template>

<script>
import RettungEintragen from './components/RettungEintragen.vue'

export default {
  name: 'App',
  components: {
    RettungEintragen
  }
}
</script>

<style>

</style>
